define('controllers/supervisor',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    'services/i18n',
    'services/user',
    // Contoller
    'src/controller/controller',
    'controllers/supervisor/member',
    'controllers/modules/template/template',
    'controllers/modules/noclient/noclient',
    'controllers/modules/onboarding/onboarding',
    // Views | Layout
    'views/app/supervisor',
    'views/app/supervisor/setting',
], function(
    // Libs
    _, Backbone, Mustache, U, i18n, User,
    // controller
    Controller,
    SupervisorMemberCtrl,
    TemplateCtrl,
    NoClientCtrl,
    OnboardingCtrl,
    // Views | Layout
    VSupervisorLayout,
    VLayoutSettingPage
) {

    var SupervisorCtrl = Controller.extend({
        authDefault: true,
        routes: {
            '*supervisor': 'index', // default from parent Controller

            'settings(/)': 'settings', // parameter, options
        },
        subRoutes: {
            member: "group/{{{groupId}}}/member/",
            template: "group/{{{groupId}}}/template/",
            noclient: "group/{{{groupId}}}/noclient/",
            onboarding: "group/{{{groupId}}}/onboarding/",
        },

        initialize: function(prefix, opt) {
            opt = opt || {};

            this.view = {};

            var role = this.role = opt.role;

            this.ctrl = {
                member: new SupervisorMemberCtrl(this.getPrefix('member', { groupId: ":groupId" }), {
                    layout: this.layoutCtrl,
                    url: this.url.member,
                    role: role,
                }),
                template: new TemplateCtrl(this.getPrefix('template', { groupId: ":groupId" }), {
                    layout: this.layoutCtrl,
                    url: this.url.template,
                    role: role
                }),
                noclient: new NoClientCtrl(this.getPrefix('noclient', { groupId: ":groupId" }), {
                    layout: this.layoutCtrl,
                    url: this.url.noclient,
                    role: role
                }),
                onboarding: new OnboardingCtrl(this.getPrefix('onboarding', { groupId: ":groupId" }), {
                    layout: this.layoutCtrl,
                    url: this.url.onboarding,
                    role: role
                }),
            };

        },

        getLayoutInstance: function() {
            return new VSupervisorLayout({
                url: _.clone(this.url),
                role: this.role,
            });
        },

        ////////////
        // routes //
        ////////////
        index: function() {

            this.redirect(Mustache.render(this.url.member, {
                groupId: 'default'
            }));
        },

        settings: function() {
            if (!this.view.advancedSettings) {
                this.view.advancedSettings = new VLayoutSettingPage();
            }
            this.getLayout().getContent().setView(this.view.advancedSettings, true);
        },

    });

    return SupervisorCtrl;
});

